import { render, staticRenderFns } from "./createPreservation.vue?vue&type=template&id=7d93c8d9&scoped=true&"
import script from "./createPreservation.vue?vue&type=script&lang=js&"
export * from "./createPreservation.vue?vue&type=script&lang=js&"
import style0 from "./createPreservation.vue?vue&type=style&index=0&id=7d93c8d9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d93c8d9",
  null
  
)

export default component.exports